import { gql, TypedDocumentNode } from "@apollo/client";

export type TaskDepartmentNotificationDestination = {
  id: string;
  workdayDepartmentName: string;
  email: string | null;
  emailEnabled: boolean;
  emailLastError: string | null;
};

export type TaskDepartmentNotificationDestinationsQueryResponse = {
  taskDepartmentNotificationDestinations: TaskDepartmentNotificationDestination[];
};

export const TASK_DEPARTMENT_NOTIFICATION_DESTINATIONS_QUERY: TypedDocumentNode<TaskDepartmentNotificationDestinationsQueryResponse> = gql`
  query TaskDepartmentNotificationDestinationsQuery {
    taskDepartmentNotificationDestinations {
      id
      workdayDepartmentName
      email
      emailEnabled
      emailLastError
    }
  }
`;
